import * as React from 'react'
import opengraph from '/static/opengraph.png'

const MetaInfo = ({ title }) => {
  return (
    <>
      <title>{title}</title>
      <meta property="og:title" content={'South Station Residences'} />
      <meta property="og:description" content={''} />
      <meta property="og:image" content={opengraph} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="website" />
    </>
  )
}

export default MetaInfo
